import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';

import { IDwLanguageList } from '../interface/language.interface';
import { IDwLanguageListService } from '../interface/language-list-service.interface';
import { DW_LANGUAGE_JSON } from '../../../config/system.config';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DwLanguageListService implements IDwLanguageListService {
  private languageListSubject: BehaviorSubject<IDwLanguageList[]>;

  constructor(
    @Inject(DW_LANGUAGE_JSON) private languageList: IDwLanguageList[], // 可用語言清單
    private http: HttpClient
  ) {
    this.languageListSubject = new BehaviorSubject<IDwLanguageList[]>(null);
    let list = JSON.parse(JSON.stringify(this.languageList));

    if (!Array.isArray(list)) {
      list = [];
    }

    this.languageListSubject.next(list);
  }

  /**
   * 取得可用語言清單
   */
  getLanguagesList(): Observable<IDwLanguageList[]> {
    return this.languageListSubject.asObservable().pipe(
      filter(obsData => obsData !== null), // 不廣播初始值
      distinctUntilChanged() // 有改變時才廣播
    );
  }


  public getAvailableLanguageInfo(): Observable<any> {
    return Observable.create(observer => {
        this.http.post<any>('A/Ii18nService/getAvailableLanguageInfo', { param: {} }).subscribe(response => {
            if (response.success && response.data.length > 0) {
              let langaugeList : IDwLanguageList[] = [];
              response.data.forEach(element => {
                const language : IDwLanguageList = {
                  label : element.languageName,
                  value : element.languageId
                }
                langaugeList.push(language);
              })
              observer.next(langaugeList);
            } else {
              observer.next([]);
            }
            observer.complete();
        }, error => {
            observer.next([]);
            observer.complete();
        });
    });
  }

}
